import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = { class: "text-medium-emphasis ml-1" };
const _hoisted_2 = { class: "autofill-diagnosis__label" };
const _hoisted_3 = { class: "text-body-2 weight-600" };
const _hoisted_4 = { class: "text-caption text-medium-emphasis" };
const _hoisted_5 = { class: "text-caption text-medium-emphasis" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 1,
    class: "text-caption text-medium-emphasis"
};
const _hoisted_8 = { class: "autofill-diagnosis__actions" };
import { computed, ref } from "vue";
import { AUTOFILL_DIAGNOSIS_SLOT, autofillConfidenceIcon } from "@/constants/autofill";
// Diagnoses autofill read from the documents, shown under the diagnosis form as a collapsible
// list: a run can return many, so the list folds away once the user has picked theirs.
export default /*@__PURE__*/ _defineComponent({
    __name: 'AutofillDiagnosisChoices',
    props: {
        diagnoses: {},
        orderInfo: {}
    },
    emits: ["applyDiagnosis"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const SLOT = AUTOFILL_DIAGNOSIS_SLOT;
        const open = ref(["diagnoses"]);
        const diagnosisKey = (diagnosis) => `${diagnosis.icd10Code || ""}|${diagnosis.name}`;
        const normalize = (value) => (value || "").trim().toLowerCase();
        const sameDiagnosis = (a, b) => normalize(a?.name) === normalize(b.name) && normalize(a?.icd10Code) === normalize(b.icd10Code);
        function isAppliedPrimary(diagnosis) {
            return sameDiagnosis({ name: props.orderInfo.primaryDiagnosisName, icd10Code: props.orderInfo.primaryDiagnosisIcd10Code }, diagnosis);
        }
        function isAppliedSecondary(diagnosis) {
            return (props.orderInfo.secondaryDiagnosis || []).some((entry) => entry?.name && sameDiagnosis(entry, diagnosis));
        }
        const appliedCount = computed(() => props.diagnoses.filter((d) => isAppliedPrimary(d) || isAppliedSecondary(d)).length);
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text");
            const _component_v_expansion_panel = _resolveComponent("v-expansion-panel");
            const _component_v_expansion_panels = _resolveComponent("v-expansion-panels");
            return (props.diagnoses.length > 0)
                ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                    key: 0,
                    modelValue: open.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                    variant: "accordion",
                    class: "autofill-diagnosis-choices"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, { value: "diagnoses" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-2" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                            icon: "mdi-auto-fix",
                                            size: "18",
                                            class: "mr-2"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(props.diagnoses.length) + " " + _toDisplayString(props.diagnoses.length === 1 ? "diagnosis" : "diagnoses") + " read from the documents ", 1),
                                        _createElementVNode("span", _hoisted_1, "— " + _toDisplayString(appliedCount.value) + " applied", 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2" }, " The first diagnosis is set as the primary; pick a different one, and add any others as secondary. ", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.diagnoses, (diagnosis, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: diagnosisKey(diagnosis),
                                                class: "autofill-diagnosis"
                                            }, [
                                                _createElementVNode("div", _hoisted_2, [
                                                    _createElementVNode("span", _hoisted_3, _toDisplayString(diagnosis.icd10Code || "No code"), 1),
                                                    (diagnosis.isPrimary)
                                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                                            key: 0,
                                                            size: "x-small",
                                                            color: "primary",
                                                            variant: "tonal",
                                                            class: "ml-2"
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                                    _createTextVNode(" marked primary ", -1)
                                                                ]))]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_4, _toDisplayString(diagnosis.name), 1),
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _createVNode(_component_v_icon, {
                                                            icon: _unref(autofillConfidenceIcon)(diagnosis.confidence),
                                                            size: "14"
                                                        }, null, 8, ["icon"]),
                                                        _createTextVNode(" " + _toDisplayString(diagnosis.sourceDocument || "Uploaded document"), 1),
                                                        (diagnosis.sourcePage)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " — page " + _toDisplayString(diagnosis.sourcePage), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    (diagnosis.evidence)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "“" + _toDisplayString(diagnosis.evidence) + "”", 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_8, [
                                                    _createVNode(_component_v_btn, {
                                                        color: isAppliedPrimary(diagnosis) ? 'success' : 'primary',
                                                        variant: isAppliedPrimary(diagnosis) ? 'flat' : 'outlined',
                                                        "prepend-icon": isAppliedPrimary(diagnosis) ? 'mdi-check' : 'mdi-numeric-1-circle-outline',
                                                        disabled: isAppliedPrimary(diagnosis) || isAppliedSecondary(diagnosis),
                                                        size: "small",
                                                        class: "mr-2 mb-2",
                                                        onClick: ($event) => (emit('applyDiagnosis', { slot: _unref(SLOT).PRIMARY, diagnosis }))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(isAppliedPrimary(diagnosis) ? "Primary diagnosis" : "Set as primary"), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["color", "variant", "prepend-icon", "disabled", "onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                        color: isAppliedSecondary(diagnosis) ? 'success' : 'primary',
                                                        variant: isAppliedSecondary(diagnosis) ? 'flat' : 'outlined',
                                                        "prepend-icon": isAppliedSecondary(diagnosis) ? 'mdi-check' : 'mdi-plus',
                                                        disabled: isAppliedPrimary(diagnosis) || isAppliedSecondary(diagnosis),
                                                        size: "small",
                                                        class: "mb-2",
                                                        onClick: ($event) => (emit('applyDiagnosis', { slot: _unref(SLOT).SECONDARY, diagnosis, index }))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(isAppliedSecondary(diagnosis) ? "Added as secondary" : "Add as secondary"), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["color", "variant", "prepend-icon", "disabled", "onClick"])
                                                ])
                                            ]));
                                        }), 128))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]))
                : _createCommentVNode("", true);
        };
    }
});
